import { NotifyHelper } from "../../../helpers/toast";
import { eThuPhiNhapHocActionsObj } from "../../action-types/thu-phi-nhap-hoc/IThuPhiNhapHocActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const thuPhiNhapHocActions = {
  ...generateActions(eThuPhiNhapHocActionsObj, "THU_PHI_NHAP_HOC"),
  ...generateActionForKey(
    eThuPhiNhapHocActionsObj,
    "THU_PHI_NHAP_HOC",
    "CREATE_BIENLAITHU_SUCCESS",
    () => {
      NotifyHelper.Success("Đã tạo biên lai");
    }
  ),
  ...generateActionForKey(
    eThuPhiNhapHocActionsObj,
    "THU_PHI_NHAP_HOC",
    "CREATE_BIENLAITHU_ERROR",
    (m) => {
      NotifyHelper.Error(m.data);
    }
  ),
  ...generateActionForKey(
    eThuPhiNhapHocActionsObj,
    "THU_PHI_NHAP_HOC",
    "ADD_NEW_TAB_BY_ID_ERROR",
    (m) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eThuPhiNhapHocActionsObj,
    "THU_PHI_NHAP_HOC",
    "UPDATE_BIENLAITHU_SUCCESS",
    () => {
      NotifyHelper.Success("Đã sửa biên lai");
    }
  ),
  ...generateActionForKey(
    eThuPhiNhapHocActionsObj,
    "THU_PHI_NHAP_HOC",
    "UPDATE_BIENLAITHU_ERROR",
    (m) => {
      NotifyHelper.Error(m.data);
    }
  ),
  ...generateActionForKey(
    eThuPhiNhapHocActionsObj,
    "THU_PHI_NHAP_HOC",
    "LOAD_EDIT_BIENLAI_ERROR",
    (m) => {
      NotifyHelper.Error(m.data);
    }
  ),
};
